import ProvisioningForm from './components/ProvisioningForm';
import store from '@/lib/store';
import Vue from 'vue';
export default function () {
	const provisioningFormEl = document.getElementById('provisioning-form');

	if (provisioningFormEl) {
		new Vue({
			el: provisioningFormEl,
			name: 'ProvisioningApp',
			components: {
				'provisioning-form': ProvisioningForm,
			},
			store,
		});
	}
}
